import styled from '@emotion/styled';
import Typography from '@material-ui/core/Typography';
import { Timer } from '@material-ui/icons';
import { ClassAttributes, createElement } from 'react';
import { FormattedDate } from 'react-intl';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';

import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';

type Props = {
  offer: {
    availableFrom: Date;
    availableTo: Date;
  };
  openingState: 'BEFORE_OPEN' | 'OPENING' | 'CLOSED';
  className?: string;
};

const dateFormat = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
} as unknown;

const OfferStatus = ({ offer, openingState, className }: ClassAttributes<HTMLElement> & Props) => {
  let openingStateMessage;
  switch (openingState) {
    case 'BEFORE_OPEN':
      openingStateMessage = (
        <FormattedDate value={offer.availableFrom} {...dateFormat}>
          {(dateMessage: string) => (
            <FormattedHTMLMessage id="offer_status.available_date.before_open.label" values={{ date: dateMessage }} />
          )}
        </FormattedDate>
      );
      break;
    case 'OPENING':
      openingStateMessage = (
        <FormattedDate value={offer.availableTo} {...dateFormat}>
          {(dateMessage: string) => (
            <FormattedHTMLMessage id="offer_status.available_date.opening.label" values={{ date: dateMessage }} />
          )}
        </FormattedDate>
      );
      break;
    case 'CLOSED':
      openingStateMessage = <FormattedMessage id="offer_status.available_date.closed.label" />;
      break;
  }

  return (
    <Root className={className}>
      <Icon />
      <OpeningState>{openingStateMessage}</OpeningState>
    </Root>
  );
};

const Root = styled('div')({
  ...gridLayoutContainer({
    columns: ['auto', 'auto', 'auto'],
    rows: ['auto'],
    areas: [['icon', 'openingState', 'workerStatus']],
    alignItems: 'center',
  }),
});

const Icon = styled(Timer)(gridLayoutItem('icon'), {
  marginRight: 6,
});

const OpeningState = styled(Typography)({
  whiteSpace: 'nowrap',
  fontWeight: 500,
});

export default OfferStatus;
